// Bloc d'un patient sur la facture imprimée d'une société ou d'une assurance (05/10/2026) : nom et identité
// (matricule, Agent ou lien, n° de bon, âge / sexe), prestations par rubrique (consultation d'abord), sous-total
// en bas ; montants dans la devise choisie, avec sa conversion si demandée. Partagé par l'impression « par patient »
// et les factures individuelles.
import { montantSelonMode, formaterMontant } from '@/utils/facture-assurance'

export default {
    name: 'facture-patient-bloc',
    props: {
        groupe: { type: Object, required: true },
        devise_mode: { type: String, default: 'principale' }
    },
    computed: {
        conversion() {
            return montantSelonMode(0, this.devise_mode, this.currency_info).conversion
        },
        colonnes() {
            return this.conversion ? 6 : 5
        }
    },
    methods: {
        montant(valeur) {
            return formaterMontant(montantSelonMode(valeur, this.devise_mode, this.currency_info))
        },
        montantConverti(valeur) {
            const resultat = montantSelonMode(valeur, this.devise_mode, this.currency_info)
            return resultat.conversion ? formaterMontant(resultat.conversion) : ''
        }
    }
}
